import { render } from "./AnnotationReviewAnnotationDetails.vue?vue&type=template&id=4d5c0c7e&scoped=true"
import script from "./AnnotationReviewAnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationReviewAnnotationDetails.vue?vue&type=script&lang=js"

import "./AnnotationReviewAnnotationDetails.vue?vue&type=style&index=0&id=4d5c0c7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5c0c7e"]])

export default __exports__